import { toYMD } from "../../../../../common/helpers/time";

class AdminInstructorSendDailyAgendaController {
  constructor($state, $stateParams, UsersModel, FlashService) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.UsersModel = UsersModel;
    this.FlashService = FlashService;
    this.loading = true;
    this.sendingAgenda = false;
    this.agendaDate = new Date();

    UsersModel.getInstructorByID($stateParams.instructorId).then((response) => {
      this.instructor = response;
      this.loading = false;
    });
  }

  sendDailyAgenda() {
    if (!this.agendaDate) {
      return;
    }
    this.sendingAgenda = true;
    this.UsersModel.sendInstructorDailyAgenda(
      this.instructor.id,
      toYMD(this.agendaDate),
    )
      .then((response) => {
        this.sendingAgenda = false;
        this.FlashService.setMessage({
          type: response.sent ? "success" : "info",
          message: response.message,
        });
      })
      .catch(() => {
        this.sendingAgenda = false;
      });
  }
}
AdminInstructorSendDailyAgendaController.$inject = [
  "$state",
  "$stateParams",
  "UsersModel",
  "FlashService",
];
export default AdminInstructorSendDailyAgendaController;
